'use strict';
const { normalizeLocale } = require('./locales.cjs');
const cookieName = 'gab_public_locale';

function readPreference(cookie) {
  if (typeof cookie !== 'string') return null;
  const matches = cookie.split(';').map(value => value.trim()).filter(value => value.startsWith(cookieName + '='));
  if (matches.length !== 1) return null;
  try { return normalizeLocale(decodeURIComponent(matches[0].slice(cookieName.length + 1))); }
  catch { return null; }
}

function preferenceCookie(locale, secure = false, clear = false) {
  if (!normalizeLocale(locale)) throw new Error('Unsupported public language preference.');
  return `${cookieName}=${clear ? '' : locale}; Path=/; Max-Age=${clear ? 0 : 31536000}; SameSite=Lax${secure ? '; Secure' : ''}`;
}

module.exports = { cookieName, readPreference, preferenceCookie };
